import React from 'react';
import Calendar from './Calendar.js';
import i18next from '../../i18n.js';
import { Accordion } from 'react-bootstrap';

const CalendarForm = (props) => {
    const months = Array.from({ length: 12 }, (_, i) => i);

    if (props.month === null || props.month === '') {
        return <div className='calendar-form'>
            <div className='calendar-form-title'>{i18next.t('calendar.fullYearCalendar')}</div>
            <Accordion defaultActiveKey='0'>
                <Accordion.Item eventKey='0'>
                    <Accordion.Header />
                    <Accordion.Body>
                        <div className={'calendar-content' + (props.month === null || props.month === '' ? '' : ' single')}>
                            {months.map((month, i) => <Calendar key={`${props.year}_${i}`} year={props.year} month={month} vacations={props.vacations} showVacations={props.showVacations} />)}
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    }
    else {
        return <div className='calendar-form'>            
            <div className='calendar-content single'>
                <Calendar year={props.year} month={props.month} vacations={props.vacations} showVacations={props.showVacations} />
            </div>
        </div>
    }
}

export default CalendarForm;